import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useDemo } from "@/context/DemoContext";
import { pct, STATE_COLORS, scoreColor } from "@/lib/format";
import { Loader2, TrendingUp } from "lucide-react";

export default function Pipeline() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const { showDemo } = useDemo();

  useEffect(() => { api.get("/pipeline", { params: { include_demo: showDemo } }).then((r) => setData(r.data)).catch(() => {}); }, [showDemo]);

  if (!data)
    return <div className="flex items-center justify-center h-96"><Loader2 className="w-8 h-8 text-[#EA7B2B] animate-spin" /></div>;

  return (
    <div className="space-y-6" data-testid="pipeline-page">
      <div>
        <h1 className="text-3xl font-light text-white">Pipeline operativa</h1>
        <p className="text-sm text-zinc-500 mt-1">Workflow delle operazioni · dallo scouting all'acquisto</p>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4" data-testid="kanban-board">
        {data.states.map((st) => {
          const cards = data.columns[st] || [];
          return (
            <div key={st} className="w-80 shrink-0" data-testid={`kanban-column-${st}`}>
              <div className="flex items-center justify-between px-3 py-2 border-b-2 mb-3" style={{ borderColor: STATE_COLORS[st] }}>
                <span className="text-sm text-zinc-200 font-medium">{st}</span>
                <span className="font-mono text-xs text-zinc-500 bg-white/5 px-2 py-0.5 rounded-sm">{cards.length}</span>
              </div>
              <div className="space-y-3">
                {cards.map((c) => (
                  <button
                    key={c.id}
                    onClick={() => navigate(`/operazioni/${c.id}`)}
                    data-testid={`kanban-card-${c.id}`}
                    className="w-full text-left bg-[#122A3F] border border-white/10 rounded-sm p-3 hover:border-white/25 hover:-translate-y-[1px] transition-all"
                  >
                    <div className="flex items-start justify-between gap-2">
                      <div className="text-sm text-white truncate">{c.indirizzo}</div>
                      <span className="font-mono text-xs px-1.5 py-0.5 rounded-sm shrink-0" style={{ color: scoreColor(c.score), backgroundColor: `${scoreColor(c.score)}1a` }}>{c.score}</span>
                    </div>
                    <div className="text-xs text-zinc-500 mt-0.5">{c.comune}</div>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-[10px] text-[#EA7B2B] uppercase tracking-wide truncate">{c.strategia}</span>
                      <span className="flex items-center gap-1 font-mono text-xs" style={{ color: c.roi > 20 ? "#10B981" : "#a1a1aa" }}>
                        <TrendingUp className="w-3 h-3" /> {pct(c.roi)}
                      </span>
                    </div>
                    {c.responsabile && <div className="text-[10px] text-zinc-600 mt-1">{c.responsabile}</div>}
                  </button>
                ))}
                {cards.length === 0 && <div className="text-xs text-zinc-700 text-center py-6 border border-dashed border-white/5 rounded-sm">—</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
